"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManyReclaimsDocument = exports.ManyClaimsDocument = exports.ManyDepositsDocument = exports.ManyGovPowerStrategiesDocument = exports.ManyBalancesDocument = exports.RoundWithHouseInfoDocument = exports.RoundDocument = exports.ManyRoundsWithHouseInfoDocument = exports.ManyRoundsDocument = exports.HouseDocument = exports.ManyHousesDocument = exports.RoundFieldsFragmentDoc = exports.TimedRoundConfigFieldsFragmentDoc = exports.GovPowerStrategyFieldsFragmentDoc = exports.HouseFieldsFragmentDoc = exports._SubgraphErrorPolicy_ = exports.Transfer_OrderBy = exports.TimedRoundConfig_OrderBy = exports.Round_OrderBy = exports.RoundVotingStrategy_OrderBy = exports.RoundProposingStrategy_OrderBy = exports.RoundImplementation_OrderBy = exports.RoundEventState = exports.RoundCreator_OrderBy = exports.Reclaim_OrderBy = exports.OrderDirection = exports.House_OrderBy = exports.HouseMetadata_OrderBy = exports.HouseImplementation_OrderBy = exports.GovPowerStrategy_OrderBy = exports.GovPowerStrategyType = exports.Deposit_OrderBy = exports.Claim_OrderBy = exports.Balance_OrderBy = exports.Award_OrderBy = exports.Asset_OrderBy = exports.AssetType = exports.Aggregation_Interval = exports.Administrative_OrderBy = exports.Account_OrderBy = void 0;
var Account_OrderBy;
(function (Account_OrderBy) {
    Account_OrderBy["Claims"] = "claims";
    Account_OrderBy["CreatedRounds"] = "createdRounds";
    Account_OrderBy["CreatorOnHouses"] = "creatorOnHouses";
    Account_OrderBy["Deposits"] = "deposits";
    Account_OrderBy["Id"] = "id";
    Account_OrderBy["IncomingTransfers"] = "incomingTransfers";
    Account_OrderBy["OutgoingTransfers"] = "outgoingTransfers";
    Account_OrderBy["OwnedHouses"] = "ownedHouses";
    Account_OrderBy["Reclamations"] = "reclamations";
})(Account_OrderBy || (exports.Account_OrderBy = Account_OrderBy = {}));
var Administrative_OrderBy;
(function (Administrative_OrderBy) {
    Administrative_OrderBy["HouseImpls"] = "houseImpls";
    Administrative_OrderBy["Id"] = "id";
    Administrative_OrderBy["Manager"] = "manager";
})(Administrative_OrderBy || (exports.Administrative_OrderBy = Administrative_OrderBy = {}));
var Aggregation_Interval;
(function (Aggregation_Interval) {
    Aggregation_Interval["Day"] = "day";
    Aggregation_Interval["Hour"] = "hour";
})(Aggregation_Interval || (exports.Aggregation_Interval = Aggregation_Interval = {}));
var AssetType;
(function (AssetType) {
    AssetType["Erc20"] = "ERC20";
    AssetType["Erc721"] = "ERC721";
    AssetType["Erc1155"] = "ERC1155";
    AssetType["Native"] = "NATIVE";
})(AssetType || (exports.AssetType = AssetType = {}));
var Asset_OrderBy;
(function (Asset_OrderBy) {
    Asset_OrderBy["AssetType"] = "assetType";
    Asset_OrderBy["Id"] = "id";
    Asset_OrderBy["Identifier"] = "identifier";
    Asset_OrderBy["Token"] = "token";
})(Asset_OrderBy || (exports.Asset_OrderBy = Asset_OrderBy = {}));
var Award_OrderBy;
(function (Award_OrderBy) {
    Award_OrderBy["Amount"] = "amount";
    Award_OrderBy["Asset"] = "asset";
    Award_OrderBy["AssetAssetType"] = "asset__assetType";
    Award_OrderBy["AssetId"] = "asset__id";
    Award_OrderBy["AssetIdentifier"] = "asset__identifier";
    Award_OrderBy["AssetToken"] = "asset__token";
    Award_OrderBy["Id"] = "id";
    Award_OrderBy["Index"] = "index";
    Award_OrderBy["Round"] = "round";
    Award_OrderBy["RoundClaimPeriodEndTimestamp"] = "round__claimPeriodEndTimestamp";
    Award_OrderBy["RoundId"] = "round__id";
    Award_OrderBy["RoundProposalPeriodDuration"] = "round__proposalPeriodDuration";
    Award_OrderBy["RoundProposalPeriodEndTimestamp"] = "round__proposalPeriodEndTimestamp";
    Award_OrderBy["RoundProposalPeriodStartTimestamp"] = "round__proposalPeriodStartTimestamp";
    Award_OrderBy["RoundProposalThreshold"] = "round__proposalThreshold";
    Award_OrderBy["RoundRegisteredAt"] = "round__registeredAt";
    Award_OrderBy["RoundRegistrationTx"] = "round__registrationTx";
    Award_OrderBy["RoundVotePeriodDuration"] = "round__votePeriodDuration";
    Award_OrderBy["RoundVotePeriodEndTimestamp"] = "round__votePeriodEndTimestamp";
    Award_OrderBy["RoundVotePeriodStartTimestamp"] = "round__votePeriodStartTimestamp";
    Award_OrderBy["RoundWinnerCount"] = "round__winnerCount";
})(Award_OrderBy || (exports.Award_OrderBy = Award_OrderBy = {}));
var Balance_OrderBy;
(function (Balance_OrderBy) {
    Balance_OrderBy["Asset"] = "asset";
    Balance_OrderBy["AssetAssetType"] = "asset__assetType";
    Balance_OrderBy["AssetId"] = "asset__id";
    Balance_OrderBy["AssetIdentifier"] = "asset__identifier";
    Balance_OrderBy["AssetToken"] = "asset__token";
    Balance_OrderBy["Balance"] = "balance";
    Balance_OrderBy["Id"] = "id";
    Balance_OrderBy["Round"] = "round";
    Balance_OrderBy["RoundCreatedAt"] = "round__createdAt";
    Balance_OrderBy["RoundCreationTxHash"] = "round__creationTxHash";
    Balance_OrderBy["RoundDescription"] = "round__description";
    Balance_OrderBy["RoundEventState"] = "round__eventState";
    Balance_OrderBy["RoundId"] = "round__id";
    Balance_OrderBy["RoundIsFullyFunded"] = "round__isFullyFunded";
    Balance_OrderBy["RoundTitle"] = "round__title";
    Balance_OrderBy["RoundType"] = "round__type";
    Balance_OrderBy["UpdatedAt"] = "updatedAt";
})(Balance_OrderBy || (exports.Balance_OrderBy = Balance_OrderBy = {}));
var Claim_OrderBy;
(function (Claim_OrderBy) {
    Claim_OrderBy["Amount"] = "amount";
    Claim_OrderBy["Asset"] = "asset";
    Claim_OrderBy["AssetAssetType"] = "asset__assetType";
    Claim_OrderBy["AssetId"] = "asset__id";
    Claim_OrderBy["AssetIdentifier"] = "asset__identifier";
    Claim_OrderBy["AssetToken"] = "asset__token";
    Claim_OrderBy["ClaimedAt"] = "claimedAt";
    Claim_OrderBy["Claimer"] = "claimer";
    Claim_OrderBy["ClaimerId"] = "claimer__id";
    Claim_OrderBy["Id"] = "id";
    Claim_OrderBy["ProposalId"] = "proposalId";
    Claim_OrderBy["Recipient"] = "recipient";
    Claim_OrderBy["Round"] = "round";
    Claim_OrderBy["RoundCreatedAt"] = "round__createdAt";
    Claim_OrderBy["RoundCreationTxHash"] = "round__creationTxHash";
    Claim_OrderBy["RoundDescription"] = "round__description";
    Claim_OrderBy["RoundEventState"] = "round__eventState";
    Claim_OrderBy["RoundId"] = "round__id";
    Claim_OrderBy["RoundIsFullyFunded"] = "round__isFullyFunded";
    Claim_OrderBy["RoundTitle"] = "round__title";
    Claim_OrderBy["RoundType"] = "round__type";
    Claim_OrderBy["TxHash"] = "txHash";
})(Claim_OrderBy || (exports.Claim_OrderBy = Claim_OrderBy = {}));
var Deposit_OrderBy;
(function (Deposit_OrderBy) {
    Deposit_OrderBy["Amount"] = "amount";
    Deposit_OrderBy["Asset"] = "asset";
    Deposit_OrderBy["AssetAssetType"] = "asset__assetType";
    Deposit_OrderBy["AssetId"] = "asset__id";
    Deposit_OrderBy["AssetIdentifier"] = "asset__identifier";
    Deposit_OrderBy["AssetToken"] = "asset__token";
    Deposit_OrderBy["DepositedAt"] = "depositedAt";
    Deposit_OrderBy["Depositor"] = "depositor";
    Deposit_OrderBy["DepositorId"] = "depositor__id";
    Deposit_OrderBy["Id"] = "id";
    Deposit_OrderBy["Round"] = "round";
    Deposit_OrderBy["RoundCreatedAt"] = "round__createdAt";
    Deposit_OrderBy["RoundCreationTxHash"] = "round__creationTxHash";
    Deposit_OrderBy["RoundDescription"] = "round__description";
    Deposit_OrderBy["RoundEventState"] = "round__eventState";
    Deposit_OrderBy["RoundId"] = "round__id";
    Deposit_OrderBy["RoundIsFullyFunded"] = "round__isFullyFunded";
    Deposit_OrderBy["RoundTitle"] = "round__title";
    Deposit_OrderBy["RoundType"] = "round__type";
    Deposit_OrderBy["TxHash"] = "txHash";
})(Deposit_OrderBy || (exports.Deposit_OrderBy = Deposit_OrderBy = {}));
var GovPowerStrategyType;
(function (GovPowerStrategyType) {
    GovPowerStrategyType["Allowlist"] = "ALLOWLIST";
    GovPowerStrategyType["BalanceOf"] = "BALANCE_OF";
    GovPowerStrategyType["BalanceOfErc20"] = "BALANCE_OF_ERC20";
    GovPowerStrategyType["BalanceOfErc1155"] = "BALANCE_OF_ERC1155";
    GovPowerStrategyType["CheckpointableErc721"] = "CHECKPOINTABLE_ERC721";
    GovPowerStrategyType["Unknown"] = "UNKNOWN";
    GovPowerStrategyType["Vanilla"] = "VANILLA";
})(GovPowerStrategyType || (exports.GovPowerStrategyType = GovPowerStrategyType = {}));
var GovPowerStrategy_OrderBy;
(function (GovPowerStrategy_OrderBy) {
    GovPowerStrategy_OrderBy["Address"] = "address";
    GovPowerStrategy_OrderBy["Id"] = "id";
    GovPowerStrategy_OrderBy["Params"] = "params";
    GovPowerStrategy_OrderBy["ProposingStrategyRounds"] = "proposingStrategyRounds";
    GovPowerStrategy_OrderBy["Type"] = "type";
    GovPowerStrategy_OrderBy["VotingStrategyRounds"] = "votingStrategyRounds";
})(GovPowerStrategy_OrderBy || (exports.GovPowerStrategy_OrderBy = GovPowerStrategy_OrderBy = {}));
var HouseImplementation_OrderBy;
(function (HouseImplementation_OrderBy) {
    HouseImplementation_OrderBy["Admin"] = "admin";
    HouseImplementation_OrderBy["AdminId"] = "admin__id";
    HouseImplementation_OrderBy["AdminManager"] = "admin__manager";
    HouseImplementation_OrderBy["Id"] = "id";
    HouseImplementation_OrderBy["IsRegistered"] = "isRegistered";
    HouseImplementation_OrderBy["RoundImpls"] = "roundImpls";
    HouseImplementation_OrderBy["Type"] = "type";
})(HouseImplementation_OrderBy || (exports.HouseImplementation_OrderBy = HouseImplementation_OrderBy = {}));
var HouseMetadata_OrderBy;
(function (HouseMetadata_OrderBy) {
    HouseMetadata_OrderBy["Description"] = "description";
    HouseMetadata_OrderBy["Id"] = "id";
    HouseMetadata_OrderBy["ImageUri"] = "imageURI";
    HouseMetadata_OrderBy["Name"] = "name";
})(HouseMetadata_OrderBy || (exports.HouseMetadata_OrderBy = HouseMetadata_OrderBy = {}));
var House_OrderBy;
(function (House_OrderBy) {
    House_OrderBy["ContractUri"] = "contractURI";
    House_OrderBy["CreatedAt"] = "createdAt";
    House_OrderBy["CreationTxHash"] = "creationTxHash";
    House_OrderBy["Creator"] = "creator";
    House_OrderBy["CreatorId"] = "creator__id";
    House_OrderBy["Id"] = "id";
    House_OrderBy["Metadata"] = "metadata";
    House_OrderBy["MetadataDescription"] = "metadata__description";
    House_OrderBy["MetadataId"] = "metadata__id";
    House_OrderBy["MetadataImageUri"] = "metadata__imageURI";
    House_OrderBy["MetadataName"] = "metadata__name";
    House_OrderBy["Owner"] = "owner";
    House_OrderBy["OwnerId"] = "owner__id";
    House_OrderBy["RoundCount"] = "roundCount";
    House_OrderBy["RoundCreators"] = "roundCreators";
    House_OrderBy["Rounds"] = "rounds";
    House_OrderBy["Type"] = "type";
})(House_OrderBy || (exports.House_OrderBy = House_OrderBy = {}));
/** Defines the order direction, either ascending or descending */
var OrderDirection;
(function (OrderDirection) {
    OrderDirection["Asc"] = "asc";
    OrderDirection["Desc"] = "desc";
})(OrderDirection || (exports.OrderDirection = OrderDirection = {}));
var Reclaim_OrderBy;
(function (Reclaim_OrderBy) {
    Reclaim_OrderBy["Amount"] = "amount";
    Reclaim_OrderBy["Asset"] = "asset";
    Reclaim_OrderBy["AssetAssetType"] = "asset__assetType";
    Reclaim_OrderBy["AssetId"] = "asset__id";
    Reclaim_OrderBy["AssetIdentifier"] = "asset__identifier";
    Reclaim_OrderBy["AssetToken"] = "asset__token";
    Reclaim_OrderBy["Id"] = "id";
    Reclaim_OrderBy["ReclaimedAt"] = "reclaimedAt";
    Reclaim_OrderBy["Reclaimer"] = "reclaimer";
    Reclaim_OrderBy["ReclaimerId"] = "reclaimer__id";
    Reclaim_OrderBy["Round"] = "round";
    Reclaim_OrderBy["RoundCreatedAt"] = "round__createdAt";
    Reclaim_OrderBy["RoundCreationTxHash"] = "round__creationTxHash";
    Reclaim_OrderBy["RoundDescription"] = "round__description";
    Reclaim_OrderBy["RoundEventState"] = "round__eventState";
    Reclaim_OrderBy["RoundId"] = "round__id";
    Reclaim_OrderBy["RoundIsFullyFunded"] = "round__isFullyFunded";
    Reclaim_OrderBy["RoundTitle"] = "round__title";
    Reclaim_OrderBy["RoundType"] = "round__type";
    Reclaim_OrderBy["TxHash"] = "txHash";
})(Reclaim_OrderBy || (exports.Reclaim_OrderBy = Reclaim_OrderBy = {}));
var RoundCreator_OrderBy;
(function (RoundCreator_OrderBy) {
    RoundCreator_OrderBy["Creator"] = "creator";
    RoundCreator_OrderBy["CreatorId"] = "creator__id";
    RoundCreator_OrderBy["House"] = "house";
    RoundCreator_OrderBy["HouseContractUri"] = "house__contractURI";
    RoundCreator_OrderBy["HouseCreatedAt"] = "house__createdAt";
    RoundCreator_OrderBy["HouseCreationTxHash"] = "house__creationTxHash";
    RoundCreator_OrderBy["HouseId"] = "house__id";
    RoundCreator_OrderBy["HouseRoundCount"] = "house__roundCount";
    RoundCreator_OrderBy["HouseType"] = "house__type";
    RoundCreator_OrderBy["Id"] = "id";
    RoundCreator_OrderBy["PassCount"] = "passCount";
})(RoundCreator_OrderBy || (exports.RoundCreator_OrderBy = RoundCreator_OrderBy = {}));
var RoundEventState;
(function (RoundEventState) {
    RoundEventState["Cancelled"] = "CANCELLED";
    RoundEventState["Created"] = "CREATED";
    RoundEventState["Finalized"] = "FINALIZED";
})(RoundEventState || (exports.RoundEventState = RoundEventState = {}));
var RoundImplementation_OrderBy;
(function (RoundImplementation_OrderBy) {
    RoundImplementation_OrderBy["HouseImpl"] = "houseImpl";
    RoundImplementation_OrderBy["HouseImplId"] = "houseImpl__id";
    RoundImplementation_OrderBy["HouseImplIsRegistered"] = "houseImpl__isRegistered";
    RoundImplementation_OrderBy["HouseImplType"] = "houseImpl__type";
    RoundImplementation_OrderBy["Id"] = "id";
    RoundImplementation_OrderBy["IsRegistered"] = "isRegistered";
    RoundImplementation_OrderBy["Type"] = "type";
})(RoundImplementation_OrderBy || (exports.RoundImplementation_OrderBy = RoundImplementation_OrderBy = {}));
var RoundProposingStrategy_OrderBy;
(function (RoundProposingStrategy_OrderBy) {
    RoundProposingStrategy_OrderBy["Id"] = "id";
    RoundProposingStrategy_OrderBy["Round"] = "round";
    RoundProposingStrategy_OrderBy["RoundCreatedAt"] = "round__createdAt";
    RoundProposingStrategy_OrderBy["RoundCreationTxHash"] = "round__creationTxHash";
    RoundProposingStrategy_OrderBy["RoundDescription"] = "round__description";
    RoundProposingStrategy_OrderBy["RoundEventState"] = "round__eventState";
    RoundProposingStrategy_OrderBy["RoundId"] = "round__id";
    RoundProposingStrategy_OrderBy["RoundIsFullyFunded"] = "round__isFullyFunded";
    RoundProposingStrategy_OrderBy["RoundTitle"] = "round__title";
    RoundProposingStrategy_OrderBy["RoundType"] = "round__type";
    RoundProposingStrategy_OrderBy["Strategy"] = "strategy";
    RoundProposingStrategy_OrderBy["StrategyAddress"] = "strategy__address";
    RoundProposingStrategy_OrderBy["StrategyId"] = "strategy__id";
    RoundProposingStrategy_OrderBy["StrategyType"] = "strategy__type";
})(RoundProposingStrategy_OrderBy || (exports.RoundProposingStrategy_OrderBy = RoundProposingStrategy_OrderBy = {}));
var RoundVotingStrategy_OrderBy;
(function (RoundVotingStrategy_OrderBy) {
    RoundVotingStrategy_OrderBy["Id"] = "id";
    RoundVotingStrategy_OrderBy["Round"] = "round";
    RoundVotingStrategy_OrderBy["RoundCreatedAt"] = "round__createdAt";
    RoundVotingStrategy_OrderBy["RoundCreationTxHash"] = "round__creationTxHash";
    RoundVotingStrategy_OrderBy["RoundDescription"] = "round__description";
    RoundVotingStrategy_OrderBy["RoundEventState"] = "round__eventState";
    RoundVotingStrategy_OrderBy["RoundId"] = "round__id";
    RoundVotingStrategy_OrderBy["RoundIsFullyFunded"] = "round__isFullyFunded";
    RoundVotingStrategy_OrderBy["RoundTitle"] = "round__title";
    RoundVotingStrategy_OrderBy["RoundType"] = "round__type";
    RoundVotingStrategy_OrderBy["Strategy"] = "strategy";
    RoundVotingStrategy_OrderBy["StrategyAddress"] = "strategy__address";
    RoundVotingStrategy_OrderBy["StrategyId"] = "strategy__id";
    RoundVotingStrategy_OrderBy["StrategyType"] = "strategy__type";
})(RoundVotingStrategy_OrderBy || (exports.RoundVotingStrategy_OrderBy = RoundVotingStrategy_OrderBy = {}));
var Round_OrderBy;
(function (Round_OrderBy) {
    Round_OrderBy["Balances"] = "balances";
    Round_OrderBy["Claims"] = "claims";
    Round_OrderBy["CreatedAt"] = "createdAt";
    Round_OrderBy["CreationTxHash"] = "creationTxHash";
    Round_OrderBy["Creator"] = "creator";
    Round_OrderBy["CreatorId"] = "creator__id";
    Round_OrderBy["Deposits"] = "deposits";
    Round_OrderBy["Description"] = "description";
    Round_OrderBy["EventState"] = "eventState";
    Round_OrderBy["House"] = "house";
    Round_OrderBy["HouseContractUri"] = "house__contractURI";
    Round_OrderBy["HouseCreatedAt"] = "house__createdAt";
    Round_OrderBy["HouseCreationTxHash"] = "house__creationTxHash";
    Round_OrderBy["HouseId"] = "house__id";
    Round_OrderBy["HouseRoundCount"] = "house__roundCount";
    Round_OrderBy["HouseType"] = "house__type";
    Round_OrderBy["Id"] = "id";
    Round_OrderBy["IsFullyFunded"] = "isFullyFunded";
    Round_OrderBy["Manager"] = "manager";
    Round_OrderBy["ManagerId"] = "manager__id";
    Round_OrderBy["ProposingStrategies"] = "proposingStrategies";
    Round_OrderBy["Reclamations"] = "reclamations";
    Round_OrderBy["TimedConfig"] = "timedConfig";
    Round_OrderBy["TimedConfigClaimPeriodEndTimestamp"] = "timedConfig__claimPeriodEndTimestamp";
    Round_OrderBy["TimedConfigId"] = "timedConfig__id";
    Round_OrderBy["TimedConfigProposalPeriodDuration"] = "timedConfig__proposalPeriodDuration";
    Round_OrderBy["TimedConfigProposalPeriodEndTimestamp"] = "timedConfig__proposalPeriodEndTimestamp";
    Round_OrderBy["TimedConfigProposalPeriodStartTimestamp"] = "timedConfig__proposalPeriodStartTimestamp";
    Round_OrderBy["TimedConfigProposalThreshold"] = "timedConfig__proposalThreshold";
    Round_OrderBy["TimedConfigRegisteredAt"] = "timedConfig__registeredAt";
    Round_OrderBy["TimedConfigRegistrationTx"] = "timedConfig__registrationTx";
    Round_OrderBy["TimedConfigVotePeriodDuration"] = "timedConfig__votePeriodDuration";
    Round_OrderBy["TimedConfigVotePeriodEndTimestamp"] = "timedConfig__votePeriodEndTimestamp";
    Round_OrderBy["TimedConfigVotePeriodStartTimestamp"] = "timedConfig__votePeriodStartTimestamp";
    Round_OrderBy["TimedConfigWinnerCount"] = "timedConfig__winnerCount";
    Round_OrderBy["Title"] = "title";
    Round_OrderBy["Transfers"] = "transfers";
    Round_OrderBy["Type"] = "type";
    Round_OrderBy["VotingStrategies"] = "votingStrategies";
})(Round_OrderBy || (exports.Round_OrderBy = Round_OrderBy = {}));
var TimedRoundConfig_OrderBy;
(function (TimedRoundConfig_OrderBy) {
    TimedRoundConfig_OrderBy["Awards"] = "awards";
    TimedRoundConfig_OrderBy["ClaimPeriodEndTimestamp"] = "claimPeriodEndTimestamp";
    TimedRoundConfig_OrderBy["Id"] = "id";
    TimedRoundConfig_OrderBy["ProposalPeriodDuration"] = "proposalPeriodDuration";
    TimedRoundConfig_OrderBy["ProposalPeriodEndTimestamp"] = "proposalPeriodEndTimestamp";
    TimedRoundConfig_OrderBy["ProposalPeriodStartTimestamp"] = "proposalPeriodStartTimestamp";
    TimedRoundConfig_OrderBy["ProposalThreshold"] = "proposalThreshold";
    TimedRoundConfig_OrderBy["RegisteredAt"] = "registeredAt";
    TimedRoundConfig_OrderBy["RegistrationTx"] = "registrationTx";
    TimedRoundConfig_OrderBy["Round"] = "round";
    TimedRoundConfig_OrderBy["RoundCreatedAt"] = "round__createdAt";
    TimedRoundConfig_OrderBy["RoundCreationTxHash"] = "round__creationTxHash";
    TimedRoundConfig_OrderBy["RoundDescription"] = "round__description";
    TimedRoundConfig_OrderBy["RoundEventState"] = "round__eventState";
    TimedRoundConfig_OrderBy["RoundId"] = "round__id";
    TimedRoundConfig_OrderBy["RoundIsFullyFunded"] = "round__isFullyFunded";
    TimedRoundConfig_OrderBy["RoundTitle"] = "round__title";
    TimedRoundConfig_OrderBy["RoundType"] = "round__type";
    TimedRoundConfig_OrderBy["VotePeriodDuration"] = "votePeriodDuration";
    TimedRoundConfig_OrderBy["VotePeriodEndTimestamp"] = "votePeriodEndTimestamp";
    TimedRoundConfig_OrderBy["VotePeriodStartTimestamp"] = "votePeriodStartTimestamp";
    TimedRoundConfig_OrderBy["WinnerCount"] = "winnerCount";
})(TimedRoundConfig_OrderBy || (exports.TimedRoundConfig_OrderBy = TimedRoundConfig_OrderBy = {}));
var Transfer_OrderBy;
(function (Transfer_OrderBy) {
    Transfer_OrderBy["Amount"] = "amount";
    Transfer_OrderBy["Asset"] = "asset";
    Transfer_OrderBy["AssetAssetType"] = "asset__assetType";
    Transfer_OrderBy["AssetId"] = "asset__id";
    Transfer_OrderBy["AssetIdentifier"] = "asset__identifier";
    Transfer_OrderBy["AssetToken"] = "asset__token";
    Transfer_OrderBy["From"] = "from";
    Transfer_OrderBy["FromId"] = "from__id";
    Transfer_OrderBy["Id"] = "id";
    Transfer_OrderBy["Round"] = "round";
    Transfer_OrderBy["RoundCreatedAt"] = "round__createdAt";
    Transfer_OrderBy["RoundCreationTxHash"] = "round__creationTxHash";
    Transfer_OrderBy["RoundDescription"] = "round__description";
    Transfer_OrderBy["RoundEventState"] = "round__eventState";
    Transfer_OrderBy["RoundId"] = "round__id";
    Transfer_OrderBy["RoundIsFullyFunded"] = "round__isFullyFunded";
    Transfer_OrderBy["RoundTitle"] = "round__title";
    Transfer_OrderBy["RoundType"] = "round__type";
    Transfer_OrderBy["To"] = "to";
    Transfer_OrderBy["ToId"] = "to__id";
    Transfer_OrderBy["TransferredAt"] = "transferredAt";
    Transfer_OrderBy["TxHash"] = "txHash";
})(Transfer_OrderBy || (exports.Transfer_OrderBy = Transfer_OrderBy = {}));
var _SubgraphErrorPolicy_;
(function (_SubgraphErrorPolicy_) {
    /** Data will be returned even if the subgraph has indexing errors */
    _SubgraphErrorPolicy_["Allow"] = "allow";
    /** If the subgraph has indexing errors, data will be omitted. The default. */
    _SubgraphErrorPolicy_["Deny"] = "deny";
})(_SubgraphErrorPolicy_ || (exports._SubgraphErrorPolicy_ = _SubgraphErrorPolicy_ = {}));
exports.HouseFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'HouseFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'House' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imageURI' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'roundCount' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'owner' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'roundCreators' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'creator' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'passCount' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
exports.GovPowerStrategyFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GovPowerStrategyFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GovPowerStrategy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'params' } },
                ],
            },
        },
    ],
};
exports.TimedRoundConfigFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'TimedRoundConfigFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TimedRoundConfig' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'winnerCount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'proposalThreshold' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'proposalPeriodStartTimestamp' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'proposalPeriodEndTimestamp' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'proposalPeriodDuration' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'votePeriodStartTimestamp' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'votePeriodEndTimestamp' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'votePeriodDuration' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'claimPeriodEndTimestamp' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'awards' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: { kind: 'EnumValue', value: 'index' },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderDirection' },
                                value: { kind: 'EnumValue', value: 'asc' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'asset' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
exports.RoundFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'RoundFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Round' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'eventState' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isFullyFunded' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'manager' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'proposingStrategies' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'strategy' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'GovPowerStrategyFields' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'votingStrategies' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'strategy' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'GovPowerStrategyFields' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timedConfig' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'TimedRoundConfigFields' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GovPowerStrategyFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GovPowerStrategy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'params' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'TimedRoundConfigFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TimedRoundConfig' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'winnerCount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'proposalThreshold' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'proposalPeriodStartTimestamp' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'proposalPeriodEndTimestamp' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'proposalPeriodDuration' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'votePeriodStartTimestamp' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'votePeriodEndTimestamp' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'votePeriodDuration' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'claimPeriodEndTimestamp' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'awards' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: { kind: 'EnumValue', value: 'index' },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderDirection' },
                                value: { kind: 'EnumValue', value: 'asc' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'asset' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
exports.ManyHousesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'manyHouses' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'House_orderBy' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderDirection' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrderDirection' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'House_filter' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'houses' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderDirection' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderDirection' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'HouseFields' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'HouseFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'House' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imageURI' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'roundCount' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'owner' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'roundCreators' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'creator' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'passCount' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
exports.HouseDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'house' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'house' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'HouseFields' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'HouseFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'House' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imageURI' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'roundCount' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'owner' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'roundCreators' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'creator' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'passCount' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
exports.ManyRoundsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'manyRounds' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Round_orderBy' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderDirection' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrderDirection' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Round_filter' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rounds' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderDirection' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderDirection' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoundFields' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GovPowerStrategyFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GovPowerStrategy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'params' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'TimedRoundConfigFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TimedRoundConfig' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'winnerCount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'proposalThreshold' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'proposalPeriodStartTimestamp' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'proposalPeriodEndTimestamp' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'proposalPeriodDuration' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'votePeriodStartTimestamp' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'votePeriodEndTimestamp' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'votePeriodDuration' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'claimPeriodEndTimestamp' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'awards' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: { kind: 'EnumValue', value: 'index' },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderDirection' },
                                value: { kind: 'EnumValue', value: 'asc' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'asset' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'RoundFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Round' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'eventState' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isFullyFunded' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'manager' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'proposingStrategies' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'strategy' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'GovPowerStrategyFields' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'votingStrategies' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'strategy' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'GovPowerStrategyFields' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timedConfig' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'TimedRoundConfigFields' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
exports.ManyRoundsWithHouseInfoDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'manyRoundsWithHouseInfo' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Round_orderBy' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderDirection' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrderDirection' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Round_filter' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rounds' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderDirection' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderDirection' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoundFields' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'house' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'HouseFields' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GovPowerStrategyFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GovPowerStrategy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'params' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'TimedRoundConfigFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TimedRoundConfig' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'winnerCount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'proposalThreshold' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'proposalPeriodStartTimestamp' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'proposalPeriodEndTimestamp' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'proposalPeriodDuration' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'votePeriodStartTimestamp' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'votePeriodEndTimestamp' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'votePeriodDuration' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'claimPeriodEndTimestamp' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'awards' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: { kind: 'EnumValue', value: 'index' },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderDirection' },
                                value: { kind: 'EnumValue', value: 'asc' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'asset' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'RoundFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Round' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'eventState' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isFullyFunded' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'manager' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'proposingStrategies' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'strategy' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'GovPowerStrategyFields' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'votingStrategies' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'strategy' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'GovPowerStrategyFields' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timedConfig' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'TimedRoundConfigFields' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'HouseFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'House' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imageURI' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'roundCount' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'owner' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'roundCreators' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'creator' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'passCount' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
exports.RoundDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'round' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'round' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoundFields' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GovPowerStrategyFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GovPowerStrategy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'params' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'TimedRoundConfigFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TimedRoundConfig' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'winnerCount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'proposalThreshold' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'proposalPeriodStartTimestamp' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'proposalPeriodEndTimestamp' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'proposalPeriodDuration' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'votePeriodStartTimestamp' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'votePeriodEndTimestamp' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'votePeriodDuration' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'claimPeriodEndTimestamp' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'awards' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: { kind: 'EnumValue', value: 'index' },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderDirection' },
                                value: { kind: 'EnumValue', value: 'asc' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'asset' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'RoundFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Round' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'eventState' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isFullyFunded' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'manager' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'proposingStrategies' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'strategy' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'GovPowerStrategyFields' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'votingStrategies' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'strategy' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'GovPowerStrategyFields' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timedConfig' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'TimedRoundConfigFields' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
exports.RoundWithHouseInfoDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'roundWithHouseInfo' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'round' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoundFields' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'house' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'HouseFields' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GovPowerStrategyFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GovPowerStrategy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'params' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'TimedRoundConfigFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TimedRoundConfig' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'winnerCount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'proposalThreshold' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'proposalPeriodStartTimestamp' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'proposalPeriodEndTimestamp' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'proposalPeriodDuration' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'votePeriodStartTimestamp' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'votePeriodEndTimestamp' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'votePeriodDuration' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'claimPeriodEndTimestamp' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'awards' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: { kind: 'EnumValue', value: 'index' },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderDirection' },
                                value: { kind: 'EnumValue', value: 'asc' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'asset' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'RoundFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Round' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'eventState' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isFullyFunded' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'manager' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'proposingStrategies' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'strategy' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'GovPowerStrategyFields' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'votingStrategies' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'strategy' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'GovPowerStrategyFields' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timedConfig' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'TimedRoundConfigFields' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'HouseFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'House' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imageURI' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'roundCount' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'owner' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'roundCreators' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'creator' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'passCount' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
exports.ManyBalancesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'manyBalances' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Balance_orderBy' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderDirection' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrderDirection' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Balance_filter' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'balances' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderDirection' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderDirection' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'round' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'asset' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'balance' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
exports.ManyGovPowerStrategiesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'manyGovPowerStrategies' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'GovPowerStrategy_orderBy' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderDirection' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrderDirection' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'GovPowerStrategy_filter' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'govPowerStrategies' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderDirection' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderDirection' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GovPowerStrategyFields' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GovPowerStrategyFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GovPowerStrategy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'params' } },
                ],
            },
        },
    ],
};
exports.ManyDepositsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'manyDeposits' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Deposit_orderBy' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderDirection' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrderDirection' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Deposit_filter' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deposits' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderDirection' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderDirection' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'txHash' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'depositedAt' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'depositor' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'asset' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'round' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
exports.ManyClaimsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'manyClaims' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Claim_orderBy' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderDirection' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrderDirection' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Claim_filter' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'claims' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderDirection' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderDirection' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'txHash' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'claimedAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'recipient' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'proposalId' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'round' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'asset' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
exports.ManyReclaimsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'manyReclaims' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Reclaim_orderBy' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderDirection' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrderDirection' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Reclaim_filter' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reclaims' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderDirection' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderDirection' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'txHash' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'reclaimer' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'reclaimedAt' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'asset' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'round' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
